'use client';

import { useState } from 'react';
import { useMondayAuth } from '@/contexts/MondayAuthContext';
import { WelcomeScreen } from './WelcomeScreen';
import { WalkthroughScreen } from './WalkthroughScreen';

type OnboardingPhase = 'welcome' | 'walkthrough';

interface OnboardingFlowProps {
  organizationId: string;
}

export function OnboardingFlow({ organizationId }: OnboardingFlowProps) {
  const [phase, setPhase] = useState<OnboardingPhase>('welcome');
  const { refreshAuth } = useMondayAuth();

  const completeOnboarding = async () => {
    try {
      await fetch('/api/organizations/onboarding', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId }),
      });
    } catch (err) {
      console.error('[Onboarding] Failed to save completion:', err);
    }
    // Refresh auth to reload org data with updated settings
    await refreshAuth();
  };

  if (phase === 'welcome') {
    return (
      <WelcomeScreen
        onStartTour={() => setPhase('walkthrough')}
        onSkip={completeOnboarding}
      />
    );
  }

  return (
    <WalkthroughScreen
      onComplete={completeOnboarding}
      onSkip={completeOnboarding}
    />
  );
}
